import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { GDStorageInterface, StoredPrelogin } from "../../../model/gd-storage";
import { BenefitMarketplaceApi } from "../../../shared/nestjs/flexible-benefit/benefit-marketplace/benefit-marketplace.api";

@Injectable()
export class BenefitBloc {
  public SFGoStorage: GDStorageInterface;
  public storedPrelogin: StoredPrelogin;
  private subscriptions: Array<Subscription> = [];

  constructor(
    public httpClient: HttpClient,
    private benefitMarketplaceApi: BenefitMarketplaceApi
  ) {}

  dispose() {
    this.subscriptions.forEach((item) => item.unsubscribe());
  }

  async synchronizeTokenMarketplace() {
    try {
      const result = await this.benefitMarketplaceApi
        .synchronizeTokenMarketplace()
        .toPromise();
      return result.data;
    } catch (e) {
      throw new Error(e);
    }
  }

  async getPersonal() {
    try {
      return this.benefitMarketplaceApi.getPersonalData().toPromise();
    } catch (e) {
      throw new Error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/benefit/benefit.bloc.ts